import { registerCollisionAnimation } from './CollisionAnimationRegistry';
import { seedRandom } from '../../../break/BreakUtils';

registerCollisionAnimation('GRAVITY_PARTICLES', (ctx, e, config, progress, elapsed, globalHue, determineColor) => {
  const particles = config.collisionEffectParticleCount || 20;
  const gravity = config.collisionEffectGravity || 0.5;
  for (let i = 0; i < particles; i++) {
    const rnd = seedRandom(e.id, i);
    const angle = rnd * Math.PI * 2;
    const speed = (2 + seedRandom(e.id, i + 100) * 8);
    const vx = Math.cos(angle) * speed;
    const vy = Math.sin(angle) * speed;

    const t = elapsed / 16.6;
    const x = e.pos.x + vx * t;
    const y = e.pos.y + vy * t + 0.5 * gravity * t * t;

    ctx.fillStyle = determineColor(i, particles);
    ctx.globalAlpha = 1 - progress;
    const size = 3 + (1 - progress) * 2;
    ctx.beginPath(); ctx.arc(x, y, size, 0, Math.PI * 2); ctx.fill();
  }
});
